// extracted by mini-css-extract-plugin
module.exports = {"container":"CBCheckBox_container__39IXs","checkbox":"CBCheckBox_checkbox__2GeTJ","label":"CBCheckBox_label__2l6Ch","checked":"CBCheckBox_checked__23bO5"};